import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Link from "next/link";
import { API } from "redux/actions/types";
import Axios from "axios";
import { setModal } from "~/redux/actions/modalActions";
import dynamic from "next/dynamic";

const FormDataEdit = dynamic(() => import("../Formular/FormDataEdit"));

export const Enrollments = ({ limit, updateCb = () => {} }) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {
        setIsLoading(true);
        const source = Axios.CancelToken.source();
        dispatch({
            type: API,
            payload: {
                url: "user/enrollments",
                method: "GET",
                cancelToken: source.token,
                data: { limit },
                onSuccess: (data) => setData(data.data),
                onFinish: () => setIsLoading(false),
            },
        });

        return () => {
            source.cancel();
        };
    }, [dispatch, limit]);

    const editEnrollment = (enrollment) => {
        dispatch(
            setModal({
                title: "Einschreibung bearbeiten",
                content: <FormDataEdit formDataId={enrollment.form_data_id} cb={updateCb} />,
                show: true,
            })
        );
    };

    return isLoading || auth.isLoading ? (
        <span>Lade ...</span>
    ) : (
        <table className="table table-borderless table-responsive-md">
            <thead>
                <tr>
                    <th scope="col">Titel</th>
                    <th scope="col">Start</th>
                    <th scope="col">Ende</th>
                    <th scope="col">Eingeschrieben am</th>
                    <th scope="col">Optionen</th>
                </tr>
            </thead>
            <tbody>
                {data.slice(0, limit).map((enrollment) => (
                    <tr key={enrollment.id}>
                        <td>
                            <Link href={`/insertions/${enrollment.club_slug}`}>
                                {enrollment.title}
                            </Link>
                        </td>
                        <td>{enrollment.start}</td>
                        <td>{enrollment.end}</td>
                        <td>{enrollment.createdAt}</td>
                        <td>
                            <button className="btn btn-warning btn-sm" onClick={() => editEnrollment(enrollment)}>
                                Bearbeiten
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
